export const biling = {
  path: "/biling",
  name: "biling",
  hidden: false,
  component: () => import("@/components/biling/index"),
  meta: {
    title: "Pembayaran",
    icon: "fa-book",
    roles: ["administrator", "pasien"]
  }
};
export default biling;



// WEBPACK FOOTER //
// ./src/router/modules/biling.js